import validationConst from '../../common/constants/validationConst';

export default {
  validateSync: (values, erorrs) => {
    const result = values.token
      ? !!(values.answer && values.newPassword && values.captchaVerified)
      : validationConst.email.test(values.login);

    return result;
  }
};



// WEBPACK FOOTER //
// ./src/containers/RestorePassword/formValidation.js